import { render, staticRenderFns } from "./SpinningWheel.vue?vue&type=template&id=647d7f84&"
import script from "./SpinningWheel.vue?vue&type=script&lang=js&"
export * from "./SpinningWheel.vue?vue&type=script&lang=js&"
import style0 from "./SpinningWheel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports